import whatInput from 'what-input';

import { chatWindowActions } from '../redux/slices/chat-window';
import { chatSession } from '../utils/session';

import styles from '../css/app.module.less';

export function toggleChatWindowVisible(
  isVisible: boolean,
  scrollTop?: number
) {
  chatSession.setWindowVisible(isVisible);

  let scrollPosition;
  if (whatInput.ask() === 'touch') {
    const classList = document.getElementById(
      'chat-application-wrapper'
    )?.classList;
    if (!isVisible) {
      document.body.classList.remove(styles.noScrollMobileChat);
      if (scrollTop) {
        document.documentElement.scrollTop = scrollTop;
        document.body.scrollTop = scrollTop;
        document.body.style.top = '';
      }
      classList?.remove(styles.chatMobileMessengerActive);
    } else {
      scrollPosition = window.scrollY || document.documentElement.scrollTop;
      document.body.style.top = `${-window.scrollY}px`;
      document.body.classList.add(styles.noScrollMobileChat);
      classList?.add(styles.chatMobileMessengerActive);
    }
  }

  return chatWindowActions.toggleChatWindowVisible({
    isVisible,
    scrollPosition
  });
}
